import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import { Reveal, SectionHeading } from '../SectionHeading';
import { SERVICES } from '../../data/siteData';

export const ServicesGrid = () => (
  <section id="services" data-testid="services-section" className="py-20 md:py-32 bg-white">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <SectionHeading
        label="Our Services"
        title="One Partner. Every Workforce Capability."
        subtitle="Seven specialized service lines — each with dedicated teams, playbooks and SLAs."
      />
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
        {SERVICES.map((s, i) => (
          <Reveal key={s.slug} delay={i * 0.06}>
            <Link
              to={`/services/${s.slug}`}
              data-testid={`service-card-${s.slug}`}
              className={`group flex flex-col h-full p-7 rounded-lg border transition-all duration-300 ${
                i === 0
                  ? 'bg-[#0A192F] border-[#0A192F] text-white hover:shadow-2xl hover:shadow-slate-900/25'
                  : 'bg-white border-slate-200 hover:border-[#0066CC]/40 hover:shadow-[0_12px_36px_rgba(10,25,47,0.10)]'
              } hover:-translate-y-1`}
            >
              <div className="flex items-start justify-between">
                <div className={`w-12 h-12 rounded-md flex items-center justify-center ${i === 0 ? 'bg-[#4DA3FF]/15 border border-[#4DA3FF]/25' : 'bg-slate-100 group-hover:bg-[#0A192F] transition-colors duration-300'}`}>
                  <s.icon className={`w-5 h-5 ${i === 0 ? 'text-[#4DA3FF]' : 'text-[#0A192F] group-hover:text-[#4DA3FF] transition-colors duration-300'}`} />
                </div>
                <ArrowUpRight className={`w-5 h-5 transition-all duration-300 group-hover:translate-x-1 group-hover:-translate-y-1 ${i === 0 ? 'text-[#4DA3FF]' : 'text-slate-300 group-hover:text-[#0066CC]'}`} />
              </div>
              <h3 className={`mt-5 text-lg font-semibold font-heading ${i === 0 ? 'text-white' : 'text-[#0A192F]'}`}>{s.name}</h3>
              <p className={`mt-2 text-sm leading-relaxed flex-1 ${i === 0 ? 'text-slate-300' : 'text-slate-600'}`}>{s.short}</p>
              <span className={`mt-5 text-sm font-semibold inline-flex items-center gap-1 ${i === 0 ? 'text-[#4DA3FF]' : 'text-[#0066CC]'}`}>
                Explore Service
              </span>
            </Link>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
